import React, { useState } from "react";
import Layouts from "../../Layouts";
import {
  FaBed,
  FaEnvelope,
  FaFlask,
  FaHeartbeat,
  FaNotesMedical,
  FaPhoneAlt,
  FaPills,
  FaProcedures,
  FaStream,
  FaUserMd,
  FaUserNurse,
  FaXRay,
} from "react-icons/fa";
import { IoBedOutline } from "react-icons/io5";
import Vitals from "./vitals";
import Medication from "./Medication";
import MedicalHistory from "./MedicalHistory";
import Labs from "./Labs";
import Radiology from "./Radiology";
import Orders from "./Orders";
import Notes from "./Notes";
import { Timeline } from "antd";

function InPatientsNew() {
  const loginObj = localStorage.getItem("login_result");
  const loggedUser = loginObj ? JSON.parse(loginObj) : null;
  const [activeTab, setActiveTab] = useState("vitals");

  const tabs = [
    { name: "Vitals", key: "vitals", icon: <FaHeartbeat /> },
    {
      name: "Medical History",
      key: "medicalHistory",
      icon: <FaNotesMedical />,
    },
    { name: "Medication", key: "medication", icon: <FaPills /> },

    { name: "Labs", key: "labReports", icon: <FaFlask /> },
    { name: "Radiology/Pathology", key: "radiology", icon: <FaXRay /> },
    { name: "Orders", key: "orders", icon: <FaProcedures /> },
    { name: "Doctor/Nurse Notes", key: "doctorNotes", icon: <FaUserMd /> },

    { name: "Timeline", key: "timeline", icon: <FaStream /> },
    { name: "Discharge Summary", key: "discharge", icon: <FaBed /> },
  ];

  return (
    <Layouts>
      <div>
        <div className="bg-white border border-[#e9edf5] rounded-lg overflow-hidden">
          <div className="grid grid-cols-12">
            {/* LEFT */}
            <div className="col-span-5 flex items-center gap-4 border-r border-[#edf1f7] px-6 py-3">
              <img
                src={"http://localhost:3000/images/profile.jpeg"}
                alt={"Kadhir"}
                className="h-[75px] w-[75px] rounded-full border-[5px] border-[#dff7e8] object-cover"
              />

              <div className="flex-1 mb-2">
                {/* Patient Name */}
                <h1 className="text-lg font-bold font-sans leading-[42px] text-[#111827]">
                  Kadhir{" "}
                </h1>

                {/* Basic Details */}
                <div className="flex items-center gap-5 text-xs font-bold font-sans text-[#4b5563]">
                  <span>27</span>
                  <span>UHID: 1234</span>
                  <span>Blood Group: B-ve</span>
                </div>

                {/* Ward / Room / Bed */}
                <div className="mt-4 flex items-center gap-2">
                  <IoBedOutline className="text-lg text-teal-500" />
                  <span className="text-xs font-sans text-gray-700">
                    <span className="font-semibold">{"Ward A"}</span>
                    <span className="mx-1 text-gray-400">/</span>
                    {"Room 12"}
                    <span className="mx-1 text-gray-400">/</span>
                    <span className="font-semibold text-teal-600">
                      {"Bed B-12"}
                    </span>
                  </span>
                </div>

                {/* Contact Details */}
                <div className="mt-5 flex items-center gap-8">
                  <div className="flex items-center gap-2 text-xs font-semibold font-sans text-[#374151]">
                    <FaPhoneAlt className="text-xs text-[#5b5bd6]" />
                    <span>{"909877676"}</span>
                  </div>

                  <div className="flex items-center gap-2 text-xs font-semibold font-sans text-[#374151]">
                    <FaEnvelope className="text-xs text-[#5b5bd6]" />
                    <span>{"kadhir@gmil.com"}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-span-7 grid grid-cols-3">
              <div className="px-6 py-5 border-r border-[#edf1f7]">
                <p className="text-[13px] text-[#6b7280]">IP Number</p>

                <h2 className="text-sm font-sans font-bold text-[#10b981] mt-2">
                  {"IP-2026-01568"}
                </h2>

                <p className="text-[13px] text-[#6b7280] mt-2">Department</p>

                <h3 className="text-sm font-sans font-semibold mt-1">
                  {"Cardiology"}
                </h3>
                <p className="text-xs font-sans font-semibold text-[#6b7280] mt-4">
                  Patient Status
                </p>

                <span className="inline-flex bg-[#dcfce7] text-[#16a34a] text-sm font-medium px-3 py-1 rounded-lg mt-2">
                  {"Stable"}
                </span>
              </div>

              <div className="px-6 py-5 border-r border-[#edf1f7]">
                <p className="text-xs font-sans font-semibold text-[#6b7280]">
                  Admission Date & Time
                </p>

                <h3 className="text-sm font-sans font-semibold mt-2">
                  {"15 Jan 2026, 10:30 AM"}
                </h3>

                <p className="text-xs font-sans font-semibold text-[#6b7280] mt-2">
                  Treatment Doctor
                </p>

                <h3 className="text-sm font-sans font-semibold mt-1">
                  {"Dr. Sharma"}
                </h3>
                <div className="flex items-center gap-3 mt-3">
                  <div>
                    <p className="text-xs text-gray-500">Assigned Nurse</p>
                    <p className="text-sm font-semibold text-gray-800 mt-2">
                      {"Priya S."}
                    </p>
                  </div>
                </div>
              </div>

              <div className="px-6 py-5">
                <div className="mt- flex flex-col gap-3">
                  <p className="text-xs text-gray-500 font-sans font-semibold">
                    Insurance
                  </p>
                  <h2 className="text-sm font-sans font-bold text-[#10b981]">
                    {"Star Health Insurance"}
                  </h2>
                  <h3 className="text-sm font-sans font-semibold ">
                    {"INR 5,00,000"}
                  </h3>
                  <button className="bg-[#5b5bd6] text-white px-2 py-1 rounded-lg text-xs font-sans font-semibold hover:bg-[#4a48b0] w-fit">
                    Fill Claim Form
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white border border-[#e9edf5] mt-5 rounded-[22px] h-[58px] px-5 flex items-center gap-10 overflow-x-auto scrollHide">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-2 h-full bg-white whitespace-nowrap text-[13px] transition-all duration-200 ${
                activeTab === tab.key
                  ? "border-b-[2px] border-brand-primaryColor font-bold text-brand-primaryColor"
                  : "font-semibold"
              }`}
            >
              <span className="text-sm">{tab.icon}</span>
              {tab.name}
            </button>
          ))}
        </div>
        <div className="bg-white border border-[#e9edf5] mt-5 rounded-[22px] px-5  overflow-x-auto scrollHide">
          {activeTab == "vitals" && <Vitals />}
          {activeTab == "medication" && <Medication />}
          {activeTab == "medicalHistory" && <MedicalHistory />}
          {activeTab == "labReports" && <Labs />}
          {activeTab == "radiology" && <Radiology />}
          {activeTab == "orders" && <Orders />}
          {activeTab == "doctorNotes" && <Notes />}
          {activeTab == "timeline" && <Timeline />}
        </div>
      </div>
    </Layouts>
  );
}

export default InPatientsNew;
